// Прямой импорт: баррел констант тянет config.ts с import.meta, его не
// транспилирует ts-jest.
import { PagePaths } from "@/admin/shared/constants/routes";

/** Сколько обращений показывает карточка на дашборде. */
export const OPEN_REQUESTS_LIMIT = 5;

const PREVIEW_LENGTH = 80;
const MINUTE_MS = 60_000;

/** «N мин назад», «N ч назад», «N дн назад». */
export function formatRequestAge(
  createdAt: string,
  now: Date = new Date()
): string {
  const created = new Date(createdAt).getTime();
  if (Number.isNaN(created)) return "";
  const minutes = Math.max(
    1,
    Math.floor((now.getTime() - created) / MINUTE_MS)
  );
  if (minutes < 60) return `${minutes} мин назад`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} ч назад`;
  return `${Math.floor(hours / 24)} дн назад`;
}

/** Темы у обращения нет: первая непустая строка сообщения, не длиннее 80 знаков. */
export function requestPreview(message: string): string {
  const line =
    message
      .split("\n")
      .map((part) => part.trim())
      .find(Boolean) ?? "";
  return line.length > PREVIEW_LENGTH
    ? `${line.slice(0, PREVIEW_LENGTH)}…`
    : line;
}

/** Диалог обращения: шаг details на странице обращений. */
export function supportRequestHref(id: string): string {
  const params = new URLSearchParams({ tab: "details", id });
  return `${PagePaths.assistantRequests}?${params.toString()}`;
}
